import { useContext } from 'react';
import { EnrichmentPropertiesContext } from './context';
import { isContact } from '../../utils';
import { useEnrichmentPolicy } from '../../EnrichmentPolicy/useEnrichmentPolicy';
export function useEnrichmentProperties() {
  var _state$context$associ, _associatedRecords$le, _state$context$proper;
  const {
    policy: enrichmentPolicy
  } = useEnrichmentPolicy();
  const machine = useContext(EnrichmentPropertiesContext);
  if (!machine) {
    throw new Error('useEnrichmentProperties must be used within EnrichmentPropertiesProvider');
  }
  const {
    state,
    send
  } = machine;
  const {
    enrichmentType
  } = state.context;
  const associatedRecords = (_state$context$associ = state.context.associatedRecords) !== null && _state$context$associ !== void 0 ? _state$context$associ : [];
  const hasAssociatedRecords = associatedRecords.length > 0;
  const onSelect = propertyNames => send({
    type: 'SELECT_PROPERTIES',
    data: {
      propertyNames
    }
  });
  const onToggleEnrichAssociatedRecords = () => {
    send('TOGGLE_ENRICH_ASSOCIATED_RECORDS');
  };
  return {
    associatedRecords,
    associatedRecordsCount: (_associatedRecords$le = associatedRecords.length) !== null && _associatedRecords$le !== void 0 ? _associatedRecords$le : 0,
    canEnrich: state.context.selectedProperties.length > 0,
    errorId: state.context.errorId,
    enrichAssociatedRecords: state.context.enrichAssociatedRecords,
    hasAssociatedRecords,
    isAutoEnrichmentNudgeOpen: state.context.isAutoEnrichmentNudgeOpen,
    isContactEnrichment: isContact(enrichmentType),
    isError: state.hasTag('error'),
    isErrorCredits: state.matches('errorCredits'),
    isErrorValidation: state.matches('errorValidation'),
    isErrorUpdates: state.matches('errorUpdates'),
    isErrorEnrichment: state.matches('errorEnrichment'),
    isLoading: state.hasTag('loading') || !enrichmentPolicy.isLoaded,
    onCloseBanner: () => send('CLOSE_BANNER'),
    onSelect,
    onEnrich: () => send('ENRICH'),
    onToggleEnrichAssociatedRecords,
    onRetry: () => send('RETRY'),
    onClose: state.context.onClose,
    properties: state.context.properties,
    propertiesCount: (_state$context$proper = state.context.properties.length) !== null && _state$context$proper !== void 0 ? _state$context$proper : 0,
    selectedProperties: state.context.selectedProperties
  };
}